export default "__VITE_ASSET__DHG4NhcQ__"